import { Reducer, createAction, createReducer } from "@reduxjs/toolkit";
import { Werkcat } from "@/models/werkcat";

export interface WerkcatsState {
    data: Werkcat[],
    loaded: boolean
}

const initialState: WerkcatsState = {
    data: [],
    loaded: false
}

const setDataAction = createAction<Werkcat[]>('werkcats/set-data')
const clearDataAction = createAction('werkcats/clear-data')

export const werkcatReducer = createReducer(
    initialState,
    (builder) => {
        builder.addCase(setDataAction, (state, action) => {
            state.data = action.payload;
            state.loaded = true;
        }).addCase(clearDataAction, (state, action) => {
            state.data = [];
            state.loaded = false;
        })
    }
)


export const werkcatActions = {
    set_data: setDataAction,
    clear_data: clearDataAction
}
